module.exports = __webpack_public_path__ + "entirePurchase.svg?08166e222c789e68bd05fd108d6abb06";